import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Store } from 'react-notifications-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamationTriangle, faTimes, faWarning } from '@fortawesome/free-solid-svg-icons';
import i18n from 'i18n/index';
const showNotification = (type, text, duration) => {
    let notificationClass = '';
    let notificationTitle = 'GENERAL.SUCCESS';
    let notificationIcon = faCheck;
    if (type === 'warning') {
        notificationClass = 'alert--warning';
        notificationTitle = 'GENERAL.WARNING';
        notificationIcon = faWarning;
    }
    if (type === 'error') {
        notificationClass = 'alert--error';
        notificationTitle = 'GENERAL.ERROR';
        notificationIcon = faExclamationTriangle;
    }
    Store.addNotification({
        content: (_jsxs("div", Object.assign({ className: `alert alert--open ${notificationClass}` }, { children: [_jsx("button", Object.assign({ className: "alert__close" }, { children: _jsx(FontAwesomeIcon, { icon: faTimes }, void 0) }), void 0), _jsx("div", Object.assign({ className: "alert__icon" }, { children: _jsx(FontAwesomeIcon, { icon: notificationIcon }, void 0) }), void 0), _jsxs("div", Object.assign({ className: "alert__text" }, { children: [_jsx("div", Object.assign({ className: "alert__title" }, { children: i18n.t(notificationTitle) }), void 0), _jsx("div", Object.assign({ className: "alert__description" }, { children: text }), void 0)] }), void 0)] }), void 0)),
        insert: 'top',
        container: 'top-right',
        animationIn: ['animate__animated animate__fadeInRight'],
        animationOut: ['animate__animated animate__fadeOutRight'],
        dismiss: {
            duration: duration || 5000,
            click: true
        }
    });
};
export default showNotification;
